import React, { Component } from 'react';
import { Container, Grid, Typography, Paper, Button } from '@material-ui/core';
import './index.css';
import ProductPaper from '../../components/rmaReasons/productPaper';
import { connect } from 'react-redux';
import { getReasons, publishRMA } from '../../store/slices/rmaSlice';
import { setErrorMessages } from '../../store/slices/orderSlice';
import { setPage } from '../../store/slices/pageSlice';

/**
 * RMA reasons screen
 *
 * @version 1.0.0
 */
class RmaReasonsScreen extends Component {

  /**
   * Constructor
   *
   * @param {Object} props - props
   * @version 1.0.0
   */
  constructor(props) {
    super(props);
    this.props = props;

    this.continue = this.continue.bind(this);
  }

  /**
   * On mount component
   */
  componentDidMount() {
    this.props.getReasons();
    window.scrollTo(0, 0);
  }

  /**
   * Send RMA to backend.
   */
  continue() {

    const messages = [];

    this.props.order.items.forEach((item, key) => {

      if (!item.checked) {
        return;
      }

      if ((item.customerReason === undefined || item.customerReason === '')) {
        messages.push({item, errorField: 'customerReason', errorMessage: 'Je moet een reden invullen'});
      }

      if ((item.customerDescription === undefined || item.customerDescription === '') && !item.inRetractionPeriod) {
        messages.push({item, errorField: 'customerDescription', errorMessage: 'Je moet een toelichting invullen'});
      }

      if ((item.subReason === undefined || !item.subReason) && item.customerReason !== undefined && item.customerReason.possibleSubReasons !== undefined && item.customerReason.possibleSubReasons.length > 0) {
        messages.push({item, errorField: 'subReason', errorMessage: 'Je moet een subreden invullen'});
      }

      if ((item.defectBy === undefined || !item.defectBy) && item.subReason !== undefined && item.subReason.showCustomerFault) {
        messages.push({item, errorField: 'defectBy', errorMessage: 'Je moet een optie kiezen'});
      }

      if ((item.imei === undefined || !item.imei) && item.type === 'refurbished') {
        messages.push({item, errorField: 'serial', errorMessage: 'Je moet een IMEI invullen'});
      }

      if (item.selectedAction === undefined || !item.selectedAction) {
        messages.push({item, errorField: 'selectedAction', errorMessage: 'Je moet een gewenste actie kiezen'});
      }
    });

    console.log(messages.length);

    this.props.setErrorMessages(messages);

    if (!messages.length) {
      console.log("Send RMA");
      this.props.publishRMA({rma: this.props.order});
    }
  }

  /**
   * Renderer
   *
   * @return {JSX} - the to render JSX.
   * @version 1.0.0
   */
  render() {

    const order = this.props.order;

    return (
      <React.Fragment>
        <Container>
          <Grid container justify="center">
            <Grid item xs={12} lg={8}>
              <Grid container>
                <Grid item xs="12">
                  <Paper onClick={this.props.prevStep} elevation={0}>
                    <Typography id="return-reason-back" className="backText" onClick={() => this.props.setPage(0)}>Terug</Typography>
                  </Paper>
                  <Typography variant="h6" gutterBottom id="return-reason" className="pageTitle">Retour reden</Typography>
                  <Typography variant="body1" gutterBottom>
                    Leg hier per product uit wat de reden is van de retourzending.
                  </Typography>
                </Grid>

                <Grid item xs="12">
                  {order.items && order.items.map((item, i) => {
                    if (item.checked) {
                      return (
                        <ProductPaper key={i} unique={i} item={item} />
                      );
                    }
                    return null;
                  })}

                </Grid>

                <Button id="continue" xs={4} variant="contained" className="confirmButton" onClick={this.continue}>
                  Retour indienen
                </Button>
              </Grid>
            </Grid>

          </Grid>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  order: state.orders.order,
  rma: state.rma,
});

const mapDispatchToProps = { getReasons, publishRMA, setPage, setErrorMessages };

export default connect(mapStateToProps, mapDispatchToProps)(RmaReasonsScreen);
